import { AlertCircle, CheckCircle, Clock, Upload, XCircle } from 'lucide-react'

interface StatusBadgeProps {
    status: string
    hasErrors: boolean
}

export default function StatusBadge({ status, hasErrors }: StatusBadgeProps) {
    const configs = {
        pending: {
            icon: Clock,
            className: "bg-yellow-100 text-yellow-800 border-yellow-200",
            label: "Pending"
        },
        processing: {
            icon: Upload,
            className: "bg-blue-100 text-blue-800 border-blue-200",
            label: "Processing"
        },
        completed: {
            icon: CheckCircle,
            className: "bg-green-100 text-green-800 border-green-200",
            label: "Completed"
        },
        failed: {
            icon: XCircle,
            className: "bg-red-100 text-red-800 border-red-200",
            label: "Failed"
        }
    }

    const config = configs[status as keyof typeof configs]
    if (!config) return null

    const Icon = config.icon
    const isCompleteWithErrors = status === 'completed' && hasErrors

    return (
        <span
            className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium border ${config.className}`}
        >
            <Icon className="w-5 h-5 mr-2"/>
            {config.label}
            {isCompleteWithErrors && (
                <AlertCircle className="w-4 h-4 ml-2 text-yellow-600"/>
            )}
        </span>
    )
}